import { PreloadedQuery } from 'react-relay';
import { ReportHubDiagnosticAssessmentTotalQuery } from '../../../../graphQLOperations/__generated__/ReportHubDiagnosticAssessmentTotalQuery.graphql';
import { FC, useEffect } from 'react';
import { ReportData, ReportSubtype } from '../../../../models/Report';
import { useReportHubPreloadedQuery } from '../../../../custom-hooks/useReportHubPreloadedQuery';
import { ReportHubSkillAssessmentsTotalQuery } from '../../../../graphQLOperations/__generated__/ReportHubSkillAssessmentsTotalQuery.graphql';
import { ReportHubOutstandingAssessmentsTotalQuery } from '../../../../graphQLOperations/__generated__/ReportHubOutstandingAssessmentsTotalQuery.graphql';
import { useAppDispatch } from '../../../../redux/hooks';
import { setReportHubFilter } from '../../../../redux/reducers/filterReportHubSlice';
import { setReportHubQuerysInProgress } from '../../../../redux/reducers/reportHubQuerysInProgress';

interface Props {
  selectedReportSubtype: ReportSubtype | null;
  triggerQueryKey: number | null;
  queryRef:
    | PreloadedQuery<ReportHubDiagnosticAssessmentTotalQuery, Record<string, unknown>>
    | PreloadedQuery<ReportHubSkillAssessmentsTotalQuery, Record<string, unknown>>
    | PreloadedQuery<ReportHubOutstandingAssessmentsTotalQuery, Record<string, unknown>>;
  values: ReportData;
  closeModalHandle: () => void;
}

const ReportHubSubFooter: FC<Props> = ({
  selectedReportSubtype,
  triggerQueryKey,
  queryRef,
  values,
  closeModalHandle,
}) => {
  const dispatch = useAppDispatch();

  const data = useReportHubPreloadedQuery(selectedReportSubtype as ReportSubtype, queryRef);
  useEffect(() => {
    if ((data || data === 0) && triggerQueryKey) {
      dispatch(
        setReportHubFilter({
          selectedReportSubtype,
          totalRecords: data,
          values,
          key: triggerQueryKey,
        }),
      );
      dispatch(setReportHubQuerysInProgress(true));
      closeModalHandle();
    }
  }, [data, triggerQueryKey]);

  return <></>;
};

export default ReportHubSubFooter;
